import React from "react";
import Contactimg01 from '../../assets/images/india.png';
import Contactimg02 from '../../assets/images/canada.png';
import Contactimg03 from '../../assets/images/usa.png';
import Contactimg04 from '../../assets/images/contact-us/englend-flag.jpg';
import Contactimg05 from '../../assets/images/map.png';

const Aboutthree = () => {
    return (
        <>
            <div className="contact-section">
                <div className="container">
                    <div className="heading-box text-center">
                        {/* <span className="heading-subtitle wow fadeInUp animated animated">
                            🤝 CONTACT US
                        </span> */}
                        <h2 className="heading-title wow fadeInUp animated animated">
                            Our Global Offices
                        </h2>
                    </div>
                    <div className="row gutter-y-30 align-items-center">
                        <div className="col-lg-6">
                            <div className="row gutter-y-30">
                                <div className="col-md-6">
                                    <div className="contact-location">
                                        <img
                                            src={Contactimg01}
                                            alt="Country-flag"
                                        />
                                        <h5>INDIA</h5>
                                    </div>
                                    <p>W-75D, Lane No. 10, Mandir Marg, Anupam Garden, Sainik Farms, Delhi 110068, India</p>
                                    <p>
                                        <a href="tel:9851295129" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <i className="fas fa-phone" style={{ marginRight: '8px' }}></i>
                                            +91 9851295129
                                        </a>
                                    </p>
                                </div>
                                <div className="col-md-6">
                                    <div className="contact-location">
                                        <img
                                            src={Contactimg02}
                                            alt="Country-flag"
                                        />
                                        <h5>CANADA</h5>
                                    </div>
                                    <p>Unit 304B 10, Gillingham Drive Brampton, ON, L6X 5A5, Canada</p>
                                    <p>
                                        <a href="tel:+16473237523" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <i className="fas fa-phone" style={{ marginRight: '8px' }}></i>
                                            +1 647-323-7523
                                        </a>
                                    </p>
                                </div>
                                <div className="col-md-6">
                                    <div className="contact-location">
                                        <img
                                            src={Contactimg03}
                                            alt="Country-flag"
                                        />
                                        <h5>US</h5>
                                    </div>
                                    <p>6415 Lake Worth Rd Ste 304, Greenacres, FL 33463, United States​</p>
                                    <p>
                                        <a href="tel:+17327342800" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <i className="fas fa-phone" style={{ marginRight: '8px' }}></i>
                                            +1 732-734-2800
                                        </a>
                                    </p>

                                </div>
                                {/* <div className="col-md-6">
                                    <div className="contact-location">
                                        <img
                                            src={Contactimg04}
                                            alt="Country-flag"
                                        />
                                        <h5>New Zealand</h5>
                                    </div>
                                    <p>32729 White Canyon, Lake Cornellhaven, AL 19490-6873</p>
                                </div> */}
                            </div>

                            {/* <div className="row gutter-y-30">
                                <center>
                                    <p>
                                        <a href="mailto:support@thenriadvisors.com" style={{ textDecoration: 'none', fontSize: '20px', color: 'inherit' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '8px' }}></i>
                                            support@thenriadvisors.com
                                        </a>
                                    </p>
                                </center>
                            </div> */}
                        </div>
                        <div className="col-lg-6">
                            <div className="map-image">
                                <img src={Contactimg05} alt="map-image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default Aboutthree;